import { 
    Accordion, 
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box
} from "@chakra-ui/react";
import { Title } from "../styles";

type Props = {
    children: React.ReactNode,
    title: any,
    icon: any,
    withPadding?: boolean,
    defaultOpen?: boolean
};

export default function AccordionComponent({ children, title, icon: Icon, withPadding = true, defaultOpen = false }: Props) {
  return (
    <Accordion width="100%" allowToggle defaultIndex={defaultOpen ? [0] : []}>
      <AccordionItem width="100%">
          <AccordionButton width="100%">
            <Box flex="1" textAlign="left">
              <Title><Icon size={23}/>{title}</Title>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          {
            withPadding ?
            <AccordionPanel pb={4}>
              {children}
            </AccordionPanel> :
            <AccordionPanel pb={0} pt={0} pl={0} pr={0}>
              {children}
            </AccordionPanel>
          }
        
      </AccordionItem>
    </Accordion>
  );
}
